<div class="dialog">
  <div mat-dialog-content>
    @if (confirmDialogModel.icon) {
      <div class="dialog-icon">
        <mat-icon class="dialog-icon-lg">{{ confirmDialogModel.icon }}</mat-icon>
      </div>
    }
    <div class="dialog-message">
      {{ confirmDialogModel.message }}
    </div>
    <div class="dialog-confirm-message" [innerHtml]="confirmDialogModel.confirmMessage"></div>
  </div>
  <div class="dialog-actions">
    <div class="dialog-actions-column">
      @if (!confirmDialogModel.hideCancelButton) {
        <button class="dwo-cancel" color="warn" mat-flat-button (click)="onCancel()">
          {{ 'components.confirm.cancel' | translate }}
        </button>
      }
    </div>
    <div class="dialog-actions-column dialog-actions-column-right">
      <button
        color="primary"
        mat-flat-button
        class="dwo-confirm"
        [mat-dialog-close]="true"
        cdkFocusInitial
        color="primary"
      >
        {{ 'components.confirm.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
